import { createRoutine } from 'redux-saga-routines';

import extendRoutine from 'utils/extendRoutines';

import { GET_BRANDS, SELECTED_BRAND } from './constants';

export const getBrands = extendRoutine(createRoutine(GET_BRANDS), ['RESET']);
export const selectedBrand = extendRoutine(createRoutine(SELECTED_BRAND), ['SELECTED', 'RESET']);
